import { useMutation } from '@apollo/client';
import { t } from '@lingui/macro';
import { useToast } from '@pocketlaw/tetris';
import { getUsersAccessByComposersQuery } from 'app/domains/templates';
import { addMutation } from './addMutation';
import { removeMutation } from './removeMutation';
export function useUpdateComposerPermissions() {
    const [add, addStates] = useMutation(addMutation);
    const { addToast } = useToast();
    const [remove, removeStates] = useMutation(removeMutation);
    const update = { add, remove };
    const loading = addStates.loading || removeStates.loading;
    const updateComposerPermissions = (options) => {
        const { type, userIds, composerIds } = options;
        update[type]({
            variables: { userIds, composerIds },
            refetchQueries: [getUsersAccessByComposersQuery],
            onError: () => {
                addToast({
                    title: t({
                        message: 'Something went wrong',
                        comment: 'toast when failing to update composer access',
                    }),
                    appearance: 'destructive',
                });
            },
            onCompleted: () => {
                addToast({
                    title: t({
                        message: 'Updated template access successfully',
                        comment: 'success toast when updating composer access',
                    }),
                    appearance: 'success',
                });
            },
        });
    };
    return { updateComposerPermissions, loading };
}
